import {slideTo} from "./functions";

$('.projects-list-tab').click(function() {
    var that = $(this),
        name = that.data('name'),
        projects = $('.projects-list-project');
    if (that.hasClass('active')) {
        return;
    }
    $('.active').removeClass('active');
    that.addClass('active');
    slideTo($('#projects-list-tabs'), 130, function() {
        if (that.data('all') === 'yes') {
            projects.stop().slideDown(250, BJLL.check);
        } else {
            projects.stop().slideUp(250, BJLL.check);
            projects.each(function() {
                var $this = $(this),
                    categories = $this.data('category')
                        .split(',')
                        .map(function(value) {
                            return value.trim();
                        });

                if (categories.includes(name)) {
                    $(this).stop().slideDown(250, null, function() {
                        $(this).css('height', 'auto');
                        AOS.refresh();
                        window.dispatchEvent(new CustomEvent('scroll'));
                    });
                }
            });
        }
    });
});

let t = setInterval(() => {
    if ($('.project-mockup').first().hasClass('lazy-loaded')) {
        clearInterval(t);
        $('.dot').removeClass('d-none');
    }
}, 50);
